import React from 'react';

import { Button, Form, InputNumber, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppSelector, useNotification } from 'segments/hooks';
import i18n from 'segments/i18n';

import { useUpdateUserDepositeMutation, useUpdateUserWithdrawMutation } from 'features/users';
import { selectActiveUserId } from 'features/users/store/usersSlice';

interface FormValues {
  amount: number;
}

type Props = {
  handleCancel: () => void;
};

export const WalletsOperationsModal = (props: Props) => {
  const {
    handleCancel,
  } = props;

  const selectedUserId = useAppSelector(selectActiveUserId);
  const { t } = useTranslation(undefined, { keyPrefix: 'user' });
  const [depositeBalance, { isLoading: depLoading, isSuccess: depSuccess, isError: depIsError, error: depError }] = useUpdateUserDepositeMutation();
  const [withdrawBalance, { isLoading: withdIsLoading, isSuccess: withdIsSuccess, isError: withdIsError, error: withdError }] = useUpdateUserWithdrawMutation();
  const [form] = Form.useForm();

  useNotification({
    isSuccess: withdIsSuccess,
    isError: withdIsError,
    error: withdError,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
    },
  });

  useNotification({
    isSuccess: depSuccess,
    isError: depIsError,
    error: depError,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
    },
  });

  if (selectedUserId === null) {
    return;
  }

  const onFinish = ({ amount }: FormValues) => {
    if (amount > 0) {
      depositeBalance({
        amount,
        id: selectedUserId
      });
    } else {
      withdrawBalance({
        amount: amount * -1,
        id: selectedUserId
      });
    }
  };

  return (
    <Modal
      open
      title={t('charge-deduct', 'Начислить/Списать  ')}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        disabled={withdIsLoading || depLoading}
        className="wallets-operations-form"
      >
        <Form.Item
          label={i18n.t('wallet.amount', 'Сумма')}
          name="amount"
          rules={[
            { required: true, message: 'Please input amount!' },
            {
              validator: (_, value) =>
                value !== 0
                  ? Promise.resolve()
                  : Promise.reject(new Error('Amount cannot be zero!')),
            }
          ]}
        >
          <InputNumber />
        </Form.Item>
        <Button type="primary" htmlType="submit" className="login-form-button">
          {i18n.t('user.go', 'Выполнить')}
        </Button>
      </Form>
    </Modal>
  );
};
